import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  ReadAsMaster: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(error)
    });
  },
  Update: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(ServerProperties.ATM_CLOUD.API + 'Asset/Link/' + params.data.Asset + '/', {
      tag : params.data.Tag
    })
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(params, error.response)
    });
  },
}


// WEBPACK FOOTER //
// ./src/App/qrreader/model.js